/* ── CTA Banner — Magnetic button + border-top attribute ── */
(function () {
  function initCtaBanner(container) {
    if (!container) return;

    /* Magnetic button effect */
    const magneticBtns = container.querySelectorAll('[data-magnetic]');
    magneticBtns.forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + x * 0.15 + 'px, ' + y * 0.15 + 'px)';
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* Init on DOM ready */
  function init() {
    document.querySelectorAll('[data-section-type="cta-banner"]').forEach(function (section) {
      initCtaBanner(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify editor re-render support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="cta-banner"]');
    if (section) {
      initCtaBanner(section);
    }
  });
})();
